<template>
  <base-button
    :disabled="disabled"
    :loading="loading"
    :type="type"
    :icon="icon"
    :icon-only="iconOnly"
    :caption="caption"
    :svg-icon="svgIcon"
    @click="handleClick"
  />
</template>
<script>
import BaseButton from '@/components/crud/BaseButton';

export default {
  components: {
    BaseButton
  },

  props: {
    disabled: {
      type: Boolean,

      default: false
    },

    loading: {
      type: Boolean,

      default: false
    },

    iconOnly: {
      type: Boolean,

      default: true
    },

    action: {
      type: String,

      default: '',

      validator: function(value) {
        // The value must match one of these strings

        return (
          ['add', 'save', 'cancel', 'saveClose', 'close', 'saveNext', 'clearFilters', 'primary'].indexOf(value) !== -1
        );
      }
    }
  },

  computed: {
    type() {
      switch (this.action) {
        case 'add':
        case 'save':
        case 'saveClose':
        case 'saveNext':
        case 'primary':
          return 'primary';

        default:
          return '';
      }
    },

    icon() {
      switch (this.action) {
        case 'add':
          return 'el-icon-circle-plus';
        case 'cancel':
        case 'close':
          return 'el-icon-close';
        default:
          return '';
      }
    },

    caption() {
      return this.$i18n.t('common.' + this.action);
    },

    svgIcon() {
      if (this.loading) {
        return '';
      }

      switch (this.action) {
        case 'save':
          return 'save';
        case 'saveClose':
          return 'saveclose';
        case 'saveNext':
          return 'savenext';
        case 'clearFilters':
          return 'clearFilters';

        default:
          return '';
      }
    }
  },

  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-navbar button {
  &.icon-only {
    font-size: 19px;
  }

  .svg-container {
    margin-right: 5px;
  }
}

@media only screen and (max-width: 767px) {
  .sub-navbar button {
    .svg-container {
      margin-left: 0px;
    }
  }
}
</style>
